import { HtmlPageMetaContextProps } from '~/components/HtmlPageMeta/HtmlPageMetaContextProps'
import { OrganizersApplicationDto } from '~/modules/Organizers/Application/GetAllOrganizers/OrganizersApplicationDto'
import { ApplicationTrophyDto } from '~/modules/Products/Application/Dtos/ApplicationTrophyDto'
import {
  TrophyDisciplineFilterOption,
  TrophyMemoriesFilter
} from '~/modules/Trophies/Application/TrophyListFilters'

export interface TrophiesPageViewModel {
  trophies: ApplicationTrophyDto[]
  organizers: OrganizersApplicationDto[]
  organizerId: string | null
  minMemories: TrophyMemoriesFilter
  disciplineOptions?: TrophyDisciplineFilterOption[]
  discipline?: string | null
  positionOptions?: string[]
  position?: string | null
  htmlPageMetaContextProps: HtmlPageMetaContextProps
}

export function fromTrophiesPagePropsToViewModel (props: TrophiesPageViewModel): TrophiesPageViewModel {
  return {
    trophies: props.trophies,
    organizers: props.organizers,
    organizerId: props.organizerId,
    minMemories: props.minMemories,
    disciplineOptions: props.disciplineOptions ?? [],
    discipline: props.discipline ?? null,
    positionOptions: props.positionOptions ?? [],
    position: props.position ?? null,
    htmlPageMetaContextProps: props.htmlPageMetaContextProps,
  }
}
